import React, {useState, useRef } from "react";
import { Popover, Overlay } from "react-bootstrap";
import { ReactComponent as InfoIcon } from "bootstrap-icons/icons/info-circle.svg";
import { Parser } from "html-to-react";

const InformationToolTip = ({ content, placement, trigger }) => {
  const [showPopover, setShowPopover] = useState(false);
  const targetRef = useRef(null);
  let popoverTimeout;

  const handleMouseEnter = () => {
    clearTimeout(popoverTimeout);
    setShowPopover(true);
  };

  const handleMouseLeave = () => {
    popoverTimeout = setTimeout(() => setShowPopover(false), 100); // Delay hiding
  };

  return (
    <div className="info-tooltip">
      <div
        ref={targetRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="tooltip-icon"
      >
        <InfoIcon />
      </div>
      {content && (
        <Overlay
          target={targetRef.current}
          show={showPopover}
          placement={placement ? placement : "top"}
        >
          <Popover
            id="popover-contained"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ pointerEvents: "auto" }}
            className="guide-popover"
          >
            <Popover.Header as="h3" className="guide-popover-header">{content.title}</Popover.Header>
            <Popover.Body className="guide-popover-body">
              <div className="guide-popover-content">{Parser().parse(content.body)}</div>
            </Popover.Body>
          </Popover>
        </Overlay>
      )}
    </div>
  );
};

export default InformationToolTip;
